<template>
  <SpPopover ref="popoverRef" class="filter mg-l-20" :height="height" inline="true" :width="width" @open="open" @close="close">
    <template #reference>
      <div class="filter-btn">
        <span>{{ $l("Filter") }}</span>
        <i class="icon-arrow-down iconfont" :class="{'arrow-down': isDown}" />
      </div>
    </template>
    <div style="padding: 20px;">
      <slot name="form" @close="close" />
    </div>
  </SpPopover>
</template>

<script>
import SpPopover from '@/components/common/SpPopover'
import SpButton from '@/components/common/SpButton'
import { ref, watch } from 'vue'
export default {
  name: 'SpFilter',
  components: {
    SpPopover,
    SpButton
  },

  props: {
    width: Number,
    height: Number
  },

  setup () {
    const popoverRef = ref(null)
    const isDown = ref(false)
    const open = () => {
      isDown.value = true
    }
    const close = () => {
      isDown.value = false
    }
    const closePopover = () => {
      isDown.value = false
      popoverRef.value.model = false
    }
    return {
      isDown,
      popoverRef,
      closePopover,
      open,
      close
    }
  }
}
</script>

<style scoped lang="less">
.filter {
  .iconfont {
    margin-left: 12px;
    transform: rotate(0deg);
    transition-duration: .5s;
    display: inline-block;
  }
  .arrow-down {
    transform: rotate(180deg);
    transition-duration: .5s;
  }
}
</style>
